import React from 'react';
import styles from '../../SidebarButton/Navbar.module.css';
import IconLangMaps from '../IconsLang/IconLangMaps';

const SidebarButton = ({
  text,
  icon,
  buttonClassName = '',
  textClassName = '',
  iconClassName = '',
}) => {
  const IconComponent = IconLangMaps[icon];

  return (
    <button className={`${styles.LangButtons} ${buttonClassName}`}>
      {IconComponent && (
        <IconComponent
          className={`${styles.sadrzajMainDugmeIkonica} ${iconClassName}`}
        />
      )}
      <span
        className={`${styles.sadrzajMainDugmeTekst} ${textClassName} ${styles.specialFont}`}
      >
        {text}
      </span>
    </button>
  );
};

export default SidebarButton;
